import { render, staticRenderFns } from "./BookingsMain.vue?vue&type=template&id=08d9b70a&"
import script from "./BookingsMain.vue?vue&type=script&lang=js&"
export * from "./BookingsMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports